import styled from 'styled-components';

export const Container = styled.div`
  .masked-input {
    background-color: #f3f7f9;
    border: 1px solid #e4eaec;
    padding: 8px 17px;
    font-size: 14px;
    border-radius: 10px;
    color: #768390;
    width: 100%;
    margin-bottom: 10px;

    &::placeholder {
      color: #a7b3ba;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/Register/styles.js